export enum DATA_QA {
  ROOT = 'delete-csv',
  CANCEL = 'delete-csv__cancel',
  CONFIRM = 'delete-csv__confirm',
}
